import { useSprintMutation, SprintMutationResult } from "sprint-common-web";

import { AssignFileRecordToCloudFileRequest } from "../../../../common/api/master-api/cloud-files/assign-file-record/AssignFileRecordToCloudFileRequest";
import { useCloudFileApi } from "../../../../common/api/master-api/cloud-files/useCloudFileApi";

export interface UseAssignFileRecordToCloudFile {
    assignFileRecordToCloudFile: SprintMutationResult<AssignFileRecordToCloudFileRequest, void>;
}

export const useAssignFileRecordToCloudFile = (): UseAssignFileRecordToCloudFile => {
    const cloudFileApi = useCloudFileApi();

    const assignFileRecordToCloudFile = useSprintMutation<AssignFileRecordToCloudFileRequest>({
        mutationFn: async ({ cloudFileId, fileRecordId }: AssignFileRecordToCloudFileRequest) => {
            if (!cloudFileId) {
                throw new Error("Cloud File ID is required to assign a file record.");
            }

            return cloudFileApi.assignFileRecordToCloudFile({ cloudFileId, fileRecordId });
        }
    });

    return {
        assignFileRecordToCloudFile
    };
};
